import { useEffect } from 'react';

function LegalLayout({ title, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#F0F9FF]">
      <section className="bg-[#0C4A8C] py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="eyebrow mb-3 text-[#BAE6FD]">Legal</p>
          <h1 className="text-3xl sm:text-4xl font-serif font-medium text-white tracking-tight">{title}</h1>
        </div>
      </section>
      <section className="bg-white max-w-3xl mx-auto mt-5 mb-5 rounded-[4px] py-12 md:py-16 px-6 md:px-10 space-y-6" style={{ boxShadow: '0 1px 3px rgba(12,74,140,0.06)' }}>
        {children}
      </section>
    </div>
  );
}

function P({ children }) { return <p className="text-[13px] text-[#3D4F5C] font-light leading-relaxed">{children}</p>; }
function H({ children }) { return <h2 className="text-lg font-serif font-medium text-[#0C4A8C] mt-8 mb-3">{children}</h2>; }

export function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy">
      <P>Last updated: January 2024</P>
      <P>TRUFORM MEN operates truformmen.com. This Privacy Policy explains how we collect, use, and protect your personal information.</P>
      <H>Information We Collect</H>
      <P>Device Information: browser type, IP address, time zone, cookies. Order Information: name, address, payment, email, phone.</P>
      <H>How We Use Your Information</H>
      <P>Order fulfillment, payments, shipping, invoices, communication. Device information for fraud screening and site optimization.</P>
      <H>Sharing</H>
      <P>We share with payment processors for secure transactions. We do not sell personal information.</P>
      <H>Your Rights</H>
      <P>Indian residents may access, correct, or delete personal data. Contact hello@truformmen.com.</P>
    </LegalLayout>
  );
}

export function RefundPage() {
  return (
    <LegalLayout title="Refund & Returns">
      <P>Last updated: January 2024</P>
      <H>Returns</H>
      <P>7-day returns on unopened products only. Original sealed packaging required. Opened products cannot be returned for hygiene reasons.</P>
      <H>How to Return</H>
      <P>Email hello@truformmen.com with order number and reason. We respond within 24 hours.</P>
      <H>Refund Process</H>
      <P>After inspection, approved refunds process in 5-7 business days to original payment method.</P>
      <H>Damaged Products</H>
      <P>Contact within 48 hours with photos. We'll replace or fully refund at no cost.</P>
    </LegalLayout>
  );
}

export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service">
      <P>Last updated: January 2024</P>
      <P>By using truformmen.com, you agree to these terms.</P>
      <H>Products & Pricing</H>
      <P>Prices subject to change. We may discontinue any product at any time.</P>
      <H>Accuracy</H>
      <P>We strive for accurate product descriptions. We do not warrant all content is error-free.</P>
      <H>Governing Law</H>
      <P>Governed by laws of India. Disputes subject to Mumbai court jurisdiction.</P>
      <H>Contact</H>
      <P>Questions: hello@truformmen.com</P>
    </LegalLayout>
  );
}
